import React from 'react';
import { MeridianSelect } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/MeridianSelect/MeridianSelect';

export interface StartTimeMeridianSelectProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function StartTimeMeridianSelect({
  name,
  id,
  disabled = false,
}: StartTimeMeridianSelectProps): JSX.Element {
  return (
    <MeridianSelect
      ariaLabel="Start time meridian"
      name={name}
      id={id}
      disabled={disabled}
    />
  );
}
